import { useTheme } from "@/context/ThemeContext";
import { useSite } from "@/context/SiteContext";

// Returns the correct logo URL for the given background theme.
// Mapping (per brand assets): the "-black" file is designed for DARK backgrounds,
// the "-white" file is designed for LIGHT backgrounds.
// Pass forceTheme="dark" for sections that are always dark (hero, footer, app band).
export function useLogo(forceTheme) {
  const { theme } = useTheme();
  const { settings } = useSite();
  const active = forceTheme || theme;
  if (active === "dark") return settings.logo_dark || settings.logo_url;
  return settings.logo_light || settings.logo_url;
}
